import { useEffect } from "react";

/**
 * Google Analytics loader — only activates when REACT_APP_GA_ID env var is set
 * at build time (e.g., G-XXXXXXXXXX). No tracking runs by default; safe to ship.
 * Also fires a page_view on route change to support SPA navigation.
 */
const GA_ID = process.env.REACT_APP_GA_ID;

export function useAnalytics(pathname) {
  useEffect(() => {
    if (!GA_ID) return;
    // Inject gtag.js once
    if (!window.__ga_loaded) {
      const s = document.createElement("script");
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag() { window.dataLayer.push(arguments); };
      window.gtag("js", new Date());
      window.gtag("config", GA_ID, { send_page_view: false });
      window.__ga_loaded = true;
    }
  }, []);

  useEffect(() => {
    if (!GA_ID || !window.gtag) return;
    window.gtag("event", "page_view", {
      page_path: pathname,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname]);
}

/**
 * Helper to track custom conversion events (e.g., sample-to-enroll click,
 * final-exam pass). No-op when analytics disabled.
 */
export function trackEvent(name, params = {}) {
  if (!GA_ID || typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", name, params);
}
